export default "__VITE_ASSET__D5C6qfJI__"